import React from "react";
import  "./styles/InnerPage.scss";

interface Props {
    children: any;
    style?: object;
}

const InnerPage: React.FC<Props> = (props: Props) => {
    return (
        <div style={props.style} className={"innerPage"}>
            {
                props.children
            }
        </div>
    )
}

export default InnerPage;